<template>
    <div>
        <div id="contact" class="pt-4 container-fluid">
            <div class="row justify-content-center">
                <div class="col-4 text-center mt-3 fs-5">
                    <img alt="Marlyse Photo" class="mt-5" src="../assets/logo_mpp_on_red_bg.png" />
                    <div class="text-white mt-5">
                        Marlyse KNOP
                    </div>
                    <div class="text-white">
                        50, Rue de la Tourelle
                    </div>
                    <div class="text-white">
                        92100 Boulogne Billancourt
                    </div>
                     <div class="text-white">
                         + 33 (0)6 85 73 52 59
                     </div>
                    <div class="text-white">
                        www.photos-presse.com
                    </div>
                    <div class="text-white">
                        contact@marlysephoto.com
                    </div>
                </div>
            </div>
        </div>
        <div class="position-absolute text-white pt-3 pb-3 ps-3 pe-3" id="contact-form">
            <div>
                <p class="fs-6">{{ title }}</p>
                <input
                    id="contact-email"
                    class="p-2 w-100"
                    v-model="email"
                    type="email"
                    :placeholder="placeHolderEmail">
                <p class="mt-4 fs-6 mb-0">{{ labelMessage }}</p>
                <textarea class="form-control rounded-0" id="contact-message" rows="6" v-model="message"></textarea>
                <button
                    class="text-white btn btn-danger border-0 rounded-1 pt-1 pb-1 ps-5 pe-5 mt-2"
                    type="submit"
                    id="contact-button-send"
                    :disabled="(!email || !REGEX_EMAIL.test(email)) || !message || isMessageSending"
                    @click="clickedSend">{{ buttonSend }}
                </button>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

import { format } from 'date-fns'

import { MessageApi } from "@/api/message-api"

import { useCommonStore } from "@/stores/common";
import { useLanguageStore } from "@/stores/language";

import { TEXT_KEYS, REGEX_EMAIL } from "@/constants";

@Options({
  components: {
  }
})
export default class Contact extends Vue {
    commonStore = useCommonStore()
  languageStore = useLanguageStore()

  email = ""
  message = ""

  api = new MessageApi()

  isMessageSending = false

  REGEX_EMAIL = REGEX_EMAIL

    get title() {
        return this.languageStore.text(TEXT_KEYS.CONTACT_TITLE)
    }

    get placeHolderEmail() {
        return this.languageStore.text(TEXT_KEYS.CONTACT_PLACEHOLDER_EMAIL)
    }

    get labelMessage() {
        return this.languageStore.text(TEXT_KEYS.CONTACT_LABEL_MESSAGE)
    }

    get buttonSend() {
        return this.languageStore.text(TEXT_KEYS.CONTACT_BUTTON_SEND)
    }

    public async clickedSend() {
        console.log("clickedSend")

        try {
            this.isMessageSending = true

            await this.api.put({
                email: this.email,
                message: this.message,
                timestamp: format(new Date(), 'yyyy-MM-dd hh:mm:ss')
            })

            this.commonStore.setToastSuccessMessage(this.languageStore.text(TEXT_KEYS.TOAST_CONTACT_SEND_MESSAGE_SUCCESS))
        } catch (error) {
            console.error(error)

            this.commonStore.setToastDangerMessage(this.languageStore.text(TEXT_KEYS.TOAST_CONTACT_SEND_MESSAGE_FAILURE))
        } finally {
            this.isMessageSending = false
        }
    }
}
</script>

<style lang="stylus">
#contact-email
    font-size: 0.9rem;

#contact-form
    top: 30%
    right: 1%
    min-width: 18rem

    background: linear-gradient(to bottom, #1B1B1B, #535353, #1B1B1B, #1B1B1B, #1B1B1B);

#contact-button-send
    font-size: 22px
</style>